import { withFilters } from '@wordpress/components';
import { Fragment } from '@wordpress/element';
import { sprintf, __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import { integrations, icons } from '../../blocks/form/constants';
import { Promo } from './promo';

const IntegrationsPlaceholder = withFilters( 'popper.settings.integrations' )(
	() => {
		return <Fragment></Fragment>;
	}
);

const Integrations = () => {
	const promoMessage = sprintf(
		/* translators: Link to site. */
		__(
			'<p>You can add mail services integrations (Mailchimp, ConvertKit, MailPoet, GetResponse and more…) to your popups with %s.</p><p>You can also send data to Google Sheets or to webhooks and more.</p>',
			'popper'
		),
		`<a href="https://popperwp.com" target="_blank">Popper Pro</a>`
	);
	return (
		<Fragment>
			<Promo message={ promoMessage } />
			<IntegrationsPlaceholder
				integrations={ integrations }
				icons={ icons }
			/>
		</Fragment>
	);
};

export default Integrations;
